import { Hub, HubCallback } from '@aws-amplify/core';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

export const useAuthListener = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const listener: HubCallback = ({ payload }) => {
      const { event, data } = payload;

      if (event === 'signInWithRedirect_failure') {
        toast.error(t('rbac:sign_in_with_redirect_error'), {
          autoClose: false,
        });
        return;
      }

      if (data instanceof Error) {
        toast.error(data.message, { autoClose: false });
      }
    };

    const subscription = Hub.listen('auth', listener);

    return () => {
      subscription();
    };
  }, []);
};
